// Post-trial Sokoby subscription helpers. Prices are NEVER defined here: amounts come
// from pricingData (reference) and the server-decided currency converter.

export type PricingPlanType = "starter" | "pro" | "enterprise";

/** pricingData plan type → `plans` table slug used by create-subscription-checkout. */
export const PLAN_TYPE_TO_SLUG: Record<PricingPlanType, string> = {
  starter: "basic",
  pro: "pro",
  enterprise: "business",
};

export interface MerchantStore {
  id: string;
  name: string;
}

type StoreRow = { id: string; store_name: string | null; created_at?: string | null };

/**
 * The merchant's REAL store: their store_settings row first (the store they built),
 * never the empty auto-created `stores` row ("my-store") when a real one exists.
 */
export function pickMerchantStore(settingsRows: StoreRow[], storesRows: StoreRow[]): MerchantStore | null {
  const byOldest = (rows: StoreRow[]) =>
    [...rows].sort((a, b) => String(a.created_at ?? "").localeCompare(String(b.created_at ?? "")));
  const s = byOldest(settingsRows)[0];
  if (s) return { id: s.id, name: s.store_name || "Ma boutique" };
  const st = byOldest(storesRows)[0];
  if (st) return { id: st.id, name: st.store_name || "Ma boutique" };
  return null;
}

/** French, non-technical messages for create-subscription-checkout error codes. */
export function subscriptionErrorMessage(code: string | null | undefined): string {
  switch (code) {
    case "AUTH_REQUIRED":
    case "SESSION_EXPIRED":
      return "Votre session a expiré. Veuillez vous reconnecter.";
    case "FORBIDDEN":
      return "Cette boutique n'est pas associée à votre compte.";
    case "PLAN_NOT_FOUND":
      return "Ce forfait n'est pas disponible pour le moment.";
    case "STRIPE_TEST_CONFIG_MISSING":
      return "Le paiement est momentanément indisponible. Veuillez réessayer plus tard.";
    default:
      return "Le paiement n'a pas pu démarrer. Veuillez réessayer.";
  }
}
